import Vue from 'vue'
import axios from "axios";
import VueRouter from 'vue-router'
import layoutMain from '../components/layout/LayoutMain'
import Home from '@/pages/home'
import User from '@/pages/user'
import Sell from '@/pages/sell'
import HomePage from '@/pages/homepage'
import dajin from '@/pages/dajin'
import acc from '@/pages/acc'

import versionTood from '@/utils/versionUpdate.js'

Vue.use(VueRouter)

const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}


const routes = [
  {
    path: '/',
    meta: {
      title: '首页'
    },
    redirect: {
      name: 'index'
    },
    component: layoutMain,
    children: [
      ...Home,
      ...Sell,
      ...HomePage,
      ...dajin,
      ...acc
    ]
  },
  ...User
]

const router = new VueRouter({
  mode: 'history',
  linkActiveClass: 'active',
  scrollBehavior (to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash
      }
    } else if (savedPosition && to.meta.keepAlive) {
      return savedPosition
    } else {
       return { x: 0, y: 0 }
    }
  },
  routes
})

router.onError((error) => {
  console.log("跳转error:"+error);
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  const targetPath = router.history.pending.fullPath;
  if (isChunkLoadFailed) {
    window.location.reload();
    //router.replace(targetPath);
  }
});

router.beforeEach((to,from,next) => {
  versionTood.isNewVersion()
  try{
    // if (to.name == 'home' || to.path == '/home') {
    //   const id = window.localStorage.getItem('gameId') || ''
    //   if (id && to.query.id != id) {
    //     next({
    //       name: 'home',
    //       query: Object.assign({}, to.query, {
    //         id
    //       }),
    //       replace: true
    //     })
    //     return
    //   }
    // }
    next()
  }catch(error) {
    console.error('路由守卫中捕获到异常：'+ error);
    next()
  }
})

export default router
